import { render, staticRenderFns } from "./ArchivesPage.vue?vue&type=template&id=9f553d18&"
import script from "./ArchivesPage.vue?vue&type=script&lang=js&"
export * from "./ArchivesPage.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports